module.exports = __webpack_public_path__ + "img/entregas.06b5c76f.svg";